import React from 'react';
import styles from './Segmented.module.css';

const Segmented = ({ options, value, onChange, disabled }) => (
  <div className={`${styles.segmented} ${disabled ? styles.disabled : ''}`}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        className={`${styles.button} ${value === option.value ? styles.active : ''}`}
        onClick={() => onChange(option.value)}
        disabled={disabled}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default Segmented;
